import styled from 'styled-components';

export const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: ${(props) => props.theme.$gray300};
  border-left: 1px solid ${(props) => props.theme.$gray400};

  .close {
    font-size: 20px;
    background: transparent;
    border: none;
    cursor: pointer;
    color: ${(props) => props.theme.$steel_blue};
    opacity: 0.7;
    margin-right: 8px;
  }

  .close:hover {
    opacity: 1;
  }

  .search-body {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
  }

  .search-results {
    max-height: calc(100vh - 180px);
    flex: 1;
    overflow-y: auto;
  }

  .btn-outline-light {
    background: transparent;
  }

  .btn-outline-light:hover {
    background-color: ${(props) => props.theme.$gray400};
  }

  hr {
    border-color: ${(props) => props.theme.$gray400};
  }
`;
